// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import VeeValidate from 'vee-validate'
import axios from './backend/vue-axios'
import store from './store'
import('../node_modules/vuetify/dist/vuetify.min.css')

Vue.config.productionTip = false
Vue.use(VeeValidate)
Vue.use(Vuetify)
/* eslint-disable no-new */
export const bus = new Vue()
new Vue({
  el: '#app',
  router,
  axios,
  store,
  VeeValidate,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js